import { useState } from "react";
import { X, Check, Loader2 } from "lucide-react";
import { sponsorInquiry } from "../lib/api";

const SLOTS = [
  { id: "homepage-top", label: "Homepage Top (728x90 banner)" },
  { id: "homepage-rect", label: "Homepage 300x250" },
  { id: "category-economy", label: "Business / Markets Section" },
  { id: "category-government", label: "Politics Section" },
  { id: "daily-brief", label: "My Daily Brief Sponsor (email/SMS)" },
  { id: "podcast", label: "Investigations Podcast Sponsor" },
];

export default function SponsorModal({ onClose }) {
  const [form, setForm] = useState({ company: "", contact_name: "", email: "", slot: "homepage-top", budget: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await sponsorInquiry(form);
      setDone(true);
    } catch (er) {
      setErr(er?.response?.data?.detail || "Could not send inquiry. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-back" onClick={onClose} data-testid="sponsor-modal">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            <div className="text-[12px] uppercase tracking-[0.16em] font-black text-[var(--blue)]">Advertise with Newseze</div>
            <h3 className="text-[22px] font-black mt-1 leading-tight">Sponsor a trusted slot.</h3>
            <p className="text-[13.5px] text-[var(--muted)] mt-1">
              Contextual placement beside curated, trust-scored stories. No outrage. No bot traffic.
            </p>
          </div>
          <button onClick={onClose} className="text-[var(--muted)] hover:text-[var(--ink)]" aria-label="Close" data-testid="sponsor-close">
            <X size={20} />
          </button>
        </div>

        {done ? (
          <div className="p-5 rounded-md bg-[#e8f7f1] border border-[var(--green)]/30 text-[var(--green)] text-[14px] font-semibold flex items-center gap-2" data-testid="sponsor-success">
            <Check size={18} /> Inquiry received — our team replies within 24 hours.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <input required className="field" placeholder="Company" value={form.company} onChange={set("company")} data-testid="sponsor-company" />
              <input required className="field" placeholder="Your name" value={form.contact_name} onChange={set("contact_name")} data-testid="sponsor-name" />
            </div>
            <input required type="email" className="field" placeholder="you@company.com" value={form.email} onChange={set("email")} data-testid="sponsor-email" />
            <select className="field" value={form.slot} onChange={set("slot")} data-testid="sponsor-slot">
              {SLOTS.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
            </select>
            <input className="field" placeholder="Approximate monthly budget (USD)" value={form.budget} onChange={set("budget")} data-testid="sponsor-budget" />
            <textarea className="field" rows={3} placeholder="Anything else we should know?" value={form.message} onChange={set("message")} data-testid="sponsor-message" />
            {err && <div className="text-[var(--red)] text-[13px]">{err}</div>}
            <button type="submit" disabled={loading} className="btn primary w-full justify-center" data-testid="sponsor-submit">
              {loading ? <><Loader2 size={14} className="animate-spin" /> Sending…</> : "Request media kit"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
